import { call, put, take, takeEvery,takeLatest, all, fork, select } from 'redux-saga/effects'
import {delay} from 'redux-saga'

import Auth from './auth/auth'

const reducer = (state,action) => state

const saga = function*(){
}

export default {
  root: true,
  key: 'root',
  reducer,
  saga,
  dependencies:[
    Auth
  ]
}



// WEBPACK FOOTER //
// ./src/redux/modules/root.js